// Central source of truth for the app store links and the device-aware
// "get the app" redirect. The /redirect route (DownloadRedirect) sniffs the
// user agent and forwards to the matching store, falling back to /download on
// desktop. This mirrors the public taranamusic.in/redirect link.

export const APP_STORE_URL =
  'https://apps.apple.com/in/app/tarana-music/id6740995739';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.tarana.taranaMusicApp&pcampaignid=web_share';

// Generic "Get the app" CTAs send users here; on a phone/tablet they land
// straight in the right store, on desktop they get the download page.
export const APP_REDIRECT_PATH = '/redirect';

export function openStore(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
